import React, { useEffect, useState } from "react";
import {
  Box,
  Checkbox,
  Collapse,
  Divider,
  FormGroup,
  FormControlLabel,
  Grid,
  ListItemText,
  ListItemIcon,
  ListItemButton,
  Menu,
  Typography,
} from "@mui/material";
import { Button } from "@mui/base";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import CommonButton from "components/commonButton/CommonButton";
import filterIcon from "assets/images/filter.svg";
import star from "assets/images/smStar.svg";
import activeFilter from "assets/images/filterBlue.svg";
import "./CommonFilter.scss";

function CommonFilter(props) {
  const { filterdata, onFilterChange, onRestFilter, filter } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedValues, setSelectedValues] = useState(
    props?.defaultStatus || []
  );
  const [dropdownOpen, setDropdownOpen] = useState(filterdata?.map(() => true));

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  useEffect(() => {
    if (props.defaultStatus?.length === 0) {
      setSelectedValues([]);
    }
  }, [props.defaultStatus]);

  const handleCheckboxChange = (event, type) => {
    const value = event.target.value;
    if (event.target.checked) {
      setSelectedValues((prevValues) => [...prevValues, value]);
    } else {
      setSelectedValues((prevValues) => prevValues.filter((v) => v !== value));
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickDropdown = (itemId) => {
    const updatedOpenState = dropdownOpen?.map((isOpen, index) =>
      itemId === filterdata[index].id ? !isOpen : isOpen
    );
    setDropdownOpen(updatedOpenState);
  };

  const handleApply = () => {
    onFilterChange(selectedValues);
    handleClose();
  };

  const handleReset = () => {
    onRestFilter();
    handleClose();
  };

  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : null}
        aria-haspopup="true"
        aria-expanded={open ? "true" : null}
        className="vendorFilterIcon commonFilter"
        onClick={handleClick}
      >
        {filter !== "textIcon" ? (
          <Box
            className="filterIconSvg justifyCenter"
            onClick={handleClick}
            role="presentation"
          >
            <img
              src={selectedValues.length > 0 ? activeFilter : filterIcon}
              alt="FilterIcon"
            />
          </Box>
        ) : (
          <Grid container alignItems={"center"} role="presentation">
            <Box
              className="filterIconSvg justifyCenter ml10"
              onClick={handleClick}
              role="presentation"
            >
              <img src={filterIcon} alt="FilterIcon" />
            </Box>
          </Grid>
        )}
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        className="filterMenu"
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <FormGroup className="filterCheckbox">
          {filterdata?.map((item, index) => (
            <div key={item.id}>
              <ListItemButton
                onClick={() => handleClickDropdown(item.id)}
              >
                <ListItemText
                  primary={item.primaryText}
                  className="filterDropDown"
                />
                <ListItemIcon className="filterDropDownIcon">
                  {dropdownOpen[index] ? (
                    <ExpandLess className="fontMedium colorBlue" />
                  ) : (
                    <ExpandMore className="fontMedium colorBlue" />
                  )}
                </ListItemIcon>
              </ListItemButton>
              <Collapse in={dropdownOpen[index]} timeout="auto" unmountOnExit>
                <FormGroup className="filterBox">
                  {item?.subItems?.map((subItem) => (
                    <FormControlLabel
                      key={subItem.value}
                      control={
                        <Checkbox
                          className="customFilterCheckbox"
                          key={props?.defaultStatus?.includes(subItem.value)}
                          onChange={(e) =>
                            handleCheckboxChange(e, item.primaryText)
                          }
                          value={subItem.value}
                          defaultChecked={props.defaultStatus?.includes(
                            subItem.value
                          )}
                        />
                      }
                      label={
                        <Typography variant="body2" className="filterText">
                          {item?.star && (
                            <img
                              src={star}
                              className="feedbackStar marginRight6"
                              alt="star"
                            />
                          )}
                          {subItem?.list ? subItem?.list : subItem?.value}
                        </Typography>
                      }
                    />
                  ))}
                </FormGroup>
              </Collapse>
              {index !== filterdata?.length - 1 && <Divider />}
            </div>
          ))}
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            ml={0}
            mt={1}
          >
            <CommonButton
              name="Reset"
              btnClass={"btnSm btnTransaparent filterReset"}
              onClick={handleReset}
            />
            <CommonButton
              name="Apply"
              btnClass={"btnSm btnYellow"}
              onClick={handleApply}
            />
          </Grid>
        </FormGroup>
      </Menu>
    </div>
  );
}

export default CommonFilter;
